























































import Vue from 'vue';
import ComponentPage from '@/components/page-constructor/ComponentPage.vue';
import ComponentUsageExample from '@/components/page-constructor/ComponentUsageExample.vue';
import ARadio from '@/components/ARadio.vue';

interface Data {
  basicUsageChecked: string;
  labelSlotChecked: string;
}

export default Vue.extend({
  name: 'Radio',
  components: {
    ComponentPage,
    ComponentUsageExample,
    ARadio,
  },
  data(): Data {
    return {
      basicUsageChecked: 'first',
      labelSlotChecked: 'left',
    };
  },
});
